import AutoCompleteDropdown from "@metacrm/metacrm-material-ui/dist/AutoCompleteDropdown";
import { useFetchTags } from "features/metadesk/redux/fetchTags";
import { find } from "lodash";
import React from "react";
import { useOutletContext } from "react-router";
import { useIntl } from "react-intl";

export default function UserTagComponent({ value = [], handleAddTag }) {
  const [entityName] = useOutletContext();
  const { tags, addTag } = useFetchTags();
  const tagOptions = tags[entityName].map((item) => ({
    ...item,
    label: item.value,
  }));
  const { formatMessage } = useIntl();

  const handleCreateNewTag = async (v) => {
    if (!v) return;
    if (!find(tags[entityName], { value: v.toString() })) {
      const data = await addTag({
        tag: {
          value: v,
        },
        entityName,
      });
      handleAddTag([...value, { ...data, label: v.toString() }]);
    }
  };

  return (
    <AutoCompleteDropdown
      value={value}
      options={tagOptions}
      placeholder={formatMessage({ id: "global.filter.select" })}
      isTag
      multiple
      onChange={(e, v) => handleAddTag(v)}
      onEnter={(value) => {
        handleCreateNewTag(value);
      }}
    />
  );
}
